import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import echarts from 'echarts'
import axios from 'axios'
import { getCookie, clearAllCookie, getUrlParam, IsNullOrEmpty, setLoginUserInfo, setCookie } from "@/utils/m-utils"
import { _realmName } from "@/utils/axios/request";
import { yzjLogin } from "@/api/api"
import 'element-ui/lib/theme-chalk/index.css';
import NProgress from 'nprogress'; //页面顶部进度条
import 'nprogress/nprogress.css';
import directives from "@/utils/directives";//实现对话框拖动，在el-dialog中加入属性接口，详情见组织结构页面
//字典类
import { DICTIONARY } from "@/utils/dictionary"
//注册全局字典
Vue.prototype.DICTIONARY = DICTIONARY;

Vue.config.productionTip = false;
Vue.prototype.$http = axios
Vue.prototype.$tableHeight = window.innerHeight - 198;//由于element-ui升级，不能动态计算高度，在此处计算全局表格高度
Vue.prototype.$dialogTableHeight = (window.innerHeight - 300) * 0.7;//由于element-ui升级，不能动态计算高度，在此处计算全局表格高度
window.drag = new Vue();
/* eslint-disable no-new */
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });   //element-ui 全局样式
Vue.prototype.$echarts = echarts;
Vue.prototype.$dateOptions = {
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近半年",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近一年",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        picker.$emit("pick", [start, end]);
      }
    }
  ]
}

// 定义全局常量
Vue.prototype.CONSTANT = {
  //流程引擎相关
  WORKFLOW: {
    PUBLIC: 25, //通用流程的type
    TEMPLATE_YES: 1,//是流程模版
    TEMPLATE_NO: 0,//不是流程模版
    CANEDIT_YES: 1, //允许编辑流程表单
    CANEDIT_NO: 0, //不允许编辑流程表单
  }
}
//小数点保留操作
Vue.directive('numberInt', {
  bind: function (el, binding, vnode) {
    const element = el.getElementsByTagName('input')[0]
    const len = binding.arg;  // 初始化设置
    element.value = Number(element.value).toFixed(len);  // 失焦时候格式化
    element.addEventListener('blur', function () {
      if (isNaN(element.value)) {
        vnode.data.model.callback(0);
      } else {
        vnode.data.model.callback(parseFloat(Number(element.value).toFixed(len)));
      }
    })
  }
});
// 路由级钩子
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth !== false)) {
    //检查登录状态
    const nextRoute = ["login"];
    let urlToken = getUrlParam("token");  //增加url获取token方式，用于第三方集成
    const token = urlToken || sessionStorage.getItem('accessToken');

    //登录状态拦截器，当token为空，且路由不等于login的时候，才拦截
    if (!token && nextRoute.indexOf(to.name) === -1) {
      next({
        path: '/login'
        // query: { redirect: to.fullPath },
      });
      return;
    } else if (urlToken) {
      sessionStorage.setItem("accessToken", token);
    }
  }
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});


//集成云之家
const action = getUrlParam('action');
const sys = getUrlParam('sys');
switch (action) {
  case "yunzhijia":
    const appsecret = getUrlParam('appsecret');
    const signkey = getUrlParam('signkey');
    const appid = getUrlParam('appid');
    const ticket = getUrlParam('ticket');
    const clientId = getUrlParam('client_id');
    const expireTime = getUrlParam('expire_time');
    // uni.setStorageSync('homeCode', sys);
    // uni.setStorageSync('isThirdParty', true); //是否第三方登录

    yzjLogin({
      appid: appid || clientId,
      appsecret,
      ticket
    }).then((data) => {
      const jsonData = data;
      sessionStorage.setItem("accessToken", jsonData.data.sessionKey);
      localStorage.setItem("selCompany", jsonData.data.tenantId);
      setCookie("accessToken", jsonData.data.sessionKey, 0, _realmName); //设置cookie，用于单点登录
      setCookie("userId", jsonData.data.userDto.userId, 0, _realmName);
      setLoginUserInfo(jsonData.data);
      const host = window.location.host.split(":")[0];
      switch (sys) {
        case "YOU_GUAN_JIA":
          window.location.href = process.env.NODE_ENV !== 'production' ? `http://${host}:9002` : "https://oilcan.gzybia.com";
          break;
        case "JI_GUAN_JIA":
          window.location.href = process.env.NODE_ENV !== 'production' ? `http://${host}:9001` : "https://equip.gzybia.com";
          break;
      }
      initVue();
    }).catch((data) => {
      initVue();
    })
    break;
}

const initVue = () => {

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    render: h => h(App),
    created() {
    },
  });
}

if (IsNullOrEmpty(action)) {
  initVue();
}



// WEBPACK FOOTER //
// ./src/main.js